import { useCallback, useState } from 'react';

import _noop from '@julofinance/web-helpers/dist/fn/noop';

interface UseDisclosureOptions {
  /**
   * @description used as default value
   */
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

function useDisclosure(options: UseDisclosureOptions = {}) {
  const {
    isOpen: isOpenProp,
    onClose: onCloseProp = _noop,
    onOpen: onOpenProp = _noop,
  } = options;

  const [isOpen, setIsOpen] = useState(isOpenProp ?? false);

  const onOpen = useCallback(() => {
    setIsOpen(true);
    onOpenProp();
  }, [onOpenProp]);

  const onClose = useCallback(() => {
    setIsOpen(false);
    onCloseProp();
  }, [onCloseProp]);

  return { isOpen, onOpen, onClose };
}

export default useDisclosure;
